import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';

import _ from 'lodash';

/* Actions */
import {
	updateBrochureParameter,
	updateBrochureProductInfo,
	updateBrochureCustomerInfo,
	updateBrochureCoverPageInfo,
	updateBrochureForMoreInfo,
	updateBrochureProductColorInfo
} from '../../../redux/actions';

import { routes } from '../../../redux/api/routes';
let { s3BucketAPIBaseURL, s3BrochureUrl } = routes;

class BrochureStep3 extends Component {

    constructor(props) {
        super(props);
        this.state = {
			errorMessage: '',
			error: {
				zipCodeError: '',
				phoneNumberError: '',
				productColorError: '',
				brochureNameError: '',
				zipCodeMoreInfoError: '',
				phoneNumberMoreInfoError: '',
				companyTitleError: '',
			},
			fileUploadStatusMessage: '',
			fileUploadStatus: false,
			fileUploadedList: [],
			fileUploadErrorMessage: ''
        }
    }

	handleFileUpload(e) {
        e.preventDefault();
        var self = this,
            files = e.target.files;
        if (files.length > 0) {
			if(files[0].size/1000 > 500) {
				self.setState({
					fileUploadErrorMessage: 'Please select file size upto 500KB',
					fileUploadStatusMessage: ''
				})
			} else {
	            self.setState({
	                fileUploadStatusMessage: 'Please wait until file is uploading.....',
	                fileUploadStatus: true,
	                fileUploadedList: [],
	                fileUploadErrorMessage: ''
	            });
	            var file = files[0],
	                reader = new FileReader();
	            reader.addEventListener('loadend', function (e) {
					const { userDetails } = self.props.state.user;
	                fetch(s3BucketAPIBaseURL, {
	                    method: "POST",
	                    headers: {
	                        'Content-Type': 'application/json',
							"Authorization": `${userDetails.jwt}${userDetails.sso}`,
	                    },
	                    body: JSON.stringify({
	                        name:  "CustomerNet/tmp/" + file.name,
	                        type: file.type
	                    })
	                }).then(function (response) {
	                    return response.json();
	                }).then(function (json) {
						var list = [];
	                    list.push({
	                        fileName: file.name,
	                        fileURL: json.uploadURL
	                    });
						self.setState({
	                        fileUploadedList: list
	                    });
						self.props.updateBrochureParameter({
							name: "customerLogo",
							value: file.name
						});
						var uploadURL = json.uploadURL;
						self.props.updateBrochureParameter({
							name: "fileURL",
							value: uploadURL.substring(0,uploadURL.indexOf("?"))
						});
	                    return fetch(json.uploadURL, {
	                        method: "PUT",
	                        body: new Blob([reader.result], {
	                            type: file.type
	                        })
	                    })
	                }).then(function () {
	                    self.setState({
	                        fileUploadStatusMessage: 'File is uploaded successfully.',
	                        fileUploadStatus: false,
	                        fileUploadErrorMessage: ''
	                    });
	                });
	            });
	            reader.readAsArrayBuffer(file);
			}
        } else {
            self.setState({
                fileUploadStatusMessage: '',
                fileUploadStatus: false,
                fileUploadedList: [],
                fileUploadErrorMessage: ''
            });
        }
    }

    handleProductInfoChange(paramName, event) {
		var paramValue = event.target.value,
			type = event.target.type;

		if(type === "checkbox") {
			paramValue = event.target.checked?"Y":"N"
		}

		if(paramName === "hasColorChoice") {
			this.setState({
				error: {
					...this.state.error,
					productColorError: ''
				}
			})
		}

		this.props.updateBrochureProductInfo({
			name: paramName,
			value: paramValue
		})
    }

	handleProductColorInfoChange(event) {
		var paramValue = event.target.value,
			productColors = this.props.state.brochure.payload.brochure.productInfo.productColors;

		if(event.target.checked) {
			productColors.push(paramValue);
			//Clear error as something is selected now
			this.setState({
				error: {
					...this.state.error,
					productColorError: ''
				}
			})
		} else {
			productColors.splice(productColors.indexOf(paramValue), 1);
		}

		this.props.updateBrochureProductColorInfo(productColors);
	}

	handleCustomerInfoChange(paramName, event) {
		if(paramName === "zipCode") {
			this.setState({
				error: {
					...this.state.error,
					zipCodeError: ''
				}
			});
		}
		if(paramName === "phone") {
			this.setState({
				error: {
					...this.state.error,
					phoneNumberError: ''
				}
			});
		}
		if(paramName === "name") {
			this.setState({
				error:{
					...this.state.error,
					companyTitleError: ''
				}
			})
		}
		this.props.updateBrochureCustomerInfo({
			name: paramName,
			value: event.target.value
		})
    }

	handleForMoreInfoChange(paramName, event) {
		if(paramName === "zipCode") {
			this.setState({
				error: {
					...this.state.error,
					zipCodeMoreInfoError: ''
				}
			});
		}
		if(paramName === "phone") {
			this.setState({
				error: {
					...this.state.error,
					phoneNumberMoreInfoError: ''
				}
			});
		}
		this.props.updateBrochureForMoreInfo({
			name: paramName,
			value: event.target.value
		})
    }

	handleBrochureParamsChange(paramName, event) {
        this.props.updateBrochureParameter({
			name: paramName,
			value: event.target.value
		})
		if(paramName == "selectedCoverPageName"){
			if(event.target.value == "No cover page"){
				this.props.updateBrochureParameter({
					name: "hasCoverPage",
					value: "N"
				})
			}
			else{
				this.props.updateBrochureParameter({
					name: "hasCoverPage",
					value: "Y"
				})
			}
		}
		if(paramName === 'brochureName') {
			this.setState({
				error:{
					...this.state.error,
					brochureNameError: ''
				}
			})
		}
    }

	isValidZipCode(value) {
		return /\d{5}(-?\d{4})?$/.test(value);
	}

	onBlurValidateZipCode(fieldName, event) {
		this.setState({
			error: {
				...this.state.error,
				[fieldName]: event.target.value !== "" && !this.isValidZipCode(event.target.value)?"error":""
			}
		});
	}

	onBlurValidatePhoneNumber(whichForm, fieldName, event) {
		this.setState({
			error: {
				...this.state.error,
				[fieldName]: event.target.value !== "" && !this.props.isValidPhoneNumber(event.target.value)?"error":""
			}
		});

		if(this.props.isValidPhoneNumber(event.target.value)) {
			if(whichForm === 'salesInfo') {
				this.props.updateBrochureForMoreInfo({
					name: 'phone',
					value: this.normalizePhoneNumber(event.target.value)
				});
			} else {
				this.props.updateBrochureCustomerInfo({
					name: 'phone',
					value: this.normalizePhoneNumber(event.target.value)
				});
			}
		}
	}

	normalizePhoneNumber(s) {
		var npa, nxx, xxxx, n;

		n = s.replace(/\D+/g, "");
		if ((/^1?([2-9]\d{2})(\d{3})(\d{4})$/).test(n)) {
			npa  = RegExp.$1;
			nxx  = RegExp.$2;
			xxxx = RegExp.$3;
			n = "(%s) %s-%s".replace(/%s/, npa).replace(/%s/, nxx).replace(/%s/, xxxx);
			return n;
		}
		return s;
	}

	handleContinue(event) {
		event.preventDefault();
		var self = this,
			errorFlag = false;
		let { state } = self.props;

		let pattern = /^[^&\n]*?(?:\s&[^&\n]*)*$/

		let compName=state.brochure.payload.brochure.customerInfo.name;

		let compTitleError=false;
		if(!pattern.test(compName)){
			compTitleError = true;
		}

		self.setState({
			errorMessage: '',
			error: {
				...self.state.error,
				productColorError: '',
				brochureNameError: ''
			}
		});

		//check whether account details alreaedy available or wait until service is returning data
		if(!self.props.getSelectedAccountNumber()) {
			errorFlag = true;
			self.setState({
				errorMessage: 'Please wait while account details are being fetched.'
			});
		}
		//validate color selection in case of only the onces selected scenario
		else if(state.brochure.payload.brochure.productInfo.hasColorChoice === "Y" && state.brochure.payload.brochure.productInfo.productColors.length === 0) {
			errorFlag = true;
			self.setState({
				errorMessage: 'Please select at least one color.',
				error: {
					...self.state.error,
					productColorError: 'error'
				}
			});
		}
		if(this.props.state.brochure.payload.brochure.brochureName === "") {
			errorFlag = true;
			self.setState({
				error: {
					...self.state.error,
					brochureNameError: 'error'
				}
			});
		}

		if(compTitleError){
			errorFlag = true;
			self.setState({
				 error:{
				...self.state.error,
				companyTitleError: 'error'
			  }
			})
		}

		if (self.state.error.zipCodeError !== '' || self.state.error.phoneNumberError !== '' || self.state.error.zipCodeMoreInfoError !== '' || self.state.error.phoneNumberMoreInfoError !== '' || self.state.error.companyTitleError !== '') {
			errorFlag = true;
		}

		if(!errorFlag) {
			//Set cover page informations
			// const { addressList, selectedAccount, orgContactPointList } = state.user;
			// let soldToAddress = null,
			// 	phoneNumber = '';
			// if(addressList && addressList.responseObject && addressList.responseObject.length > 0) {
			// 	soldToAddress = _.find(addressList.responseObject, ['PURPOSE', 'SOLD_TO']);
			// }
			// if(orgContactPointList && orgContactPointList.responseObject && orgContactPointList.responseObject.length > 0) {
			// 	phoneNumber = _.find(orgContactPointList.responseObject, { 'CONTACTTYPE': 'PHONE', 'PRIMARYINDICATOR': 'Y' });
			// 	phoneNumber = phoneNumber && phoneNumber.CONTACTVALUE;
			// 	phoneNumber = phoneNumber && phoneNumber.replace(/-/g, '');
			// }
			// if(soldToAddress) {
			// 	self.props.updateBrochureCoverPageInfo({
			// 		name: selectedAccount.ORGANIZATIONNAME,
			//         address1: soldToAddress.ADDRESS1,
			//         address2: "",
			//         city: soldToAddress.CITY,
			//         state: soldToAddress.STATE,
			//         zipCode: soldToAddress.POSTALCODE,
			//         phone: phoneNumber,
			// 		additionalInfo: this.additionalInfo.value?this.additionalInfo.value.trim():this.additionalInfo.value
			// 	});
			// } else {
			// 	self.props.updateBrochureCoverPageInfo({
			// 		name: "",
			//         address1: "",
			//         address2: "",
			//         city: "",
			//         state: "",
			//         zipCode: "",
			//         phone: "",
			// 		additionalInfo: this.additionalInfo.value?this.additionalInfo.value.trim():this.additionalInfo.value
			// 	});
			// }
			//Go to step 4
			browserHistory.push("/create-brochure-step4");
		}
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		if(this.props.state.brochure.selectedItems.length === 0) {
			//Redirect to list page if user directly comes on this page
			browserHistory.push("/list");
		}
	}

	componentWillMount() {
		const self = this;
		const { user, brochure: { payload: { brochure : { customerInfo, brochureId } } } } = this.props.state;
		const { addressList, orgContactPointList } = user;
		let soldToAddress = null;
		// if all fields are blank then set it else keep it as it is (In case of Edit Brochure it will always set before coming here so need to keep it as it is)
		if(customerInfo.name === '' && customerInfo.address1 === '' && customerInfo.address2 === '' && customerInfo.city === '' && customerInfo.state === '' && customerInfo.zipCode === '' && customerInfo.phone === '') {
			if(addressList && addressList.responseObject && addressList.responseObject.length > 0) {
				let phoneNumber = '';
				if(orgContactPointList && orgContactPointList.responseObject && orgContactPointList.responseObject.length > 0) {
					phoneNumber = _.find(orgContactPointList.responseObject, { 'CONTACTTYPE': 'PHONE', 'PRIMARYINDICATOR': 'Y' });
					phoneNumber = phoneNumber && phoneNumber.CONTACTPHONE;
					phoneNumber = phoneNumber && phoneNumber.replace(/-/g, '');
				}
				soldToAddress = self.props.getAddressByCategory('SOLD_TO', false);
				if (soldToAddress) {
					self.handleCustomerInfoChange('name', { target: { value: ''}});
					self.handleCustomerInfoChange('address1', { target: { value: soldToAddress.ADDRESS1 }});
					self.handleCustomerInfoChange('address2', { target: { value: '' }});
					self.handleCustomerInfoChange('city', { target: { value: soldToAddress.CITY }});
					self.handleCustomerInfoChange('state', { target: { value: soldToAddress.STATE }});
					self.handleCustomerInfoChange('zipCode', { target: { value: soldToAddress.POSTALCODE }});
					self.handleCustomerInfoChange('phone', { target: { value: phoneNumber }});
				}
			}
		}

		const { userDetails } = user;
		self.props.updateBrochureForMoreInfo({
			name: 'name',
			value: userDetails.firstName + ' ' + userDetails.lastName
		});
		self.props.updateBrochureForMoreInfo({
			name: 'email',
			value: userDetails.email
		});
		// only set these details in case of create only, keep it as it is in case of edit.
		if(!brochureId && userDetails && userDetails.typeOfUser === 'employee') {
			self.props.updateBrochureForMoreInfo({
				name: 'address1',
				value: ''
			});
			self.props.updateBrochureForMoreInfo({
				name: 'city',
				value: ''
			});
			self.props.updateBrochureForMoreInfo({
				name: 'state',
				value: ''
			});
			self.props.updateBrochureForMoreInfo({
				name: 'zipCode',
				value: ''
			});
			self.props.updateBrochureForMoreInfo({
				name: 'phone',
				value: ''
			});
		}
	}

    render() {
		const { brochure } = this.props.state;
		const {coverPageTemplateOptions} = brochure
		{/*new brochure single changes*/}
		brochure.payload.brochure.hasCoverPageWithImage = brochure.payload.brochure.hasCoverPageWithImage ? brochure.payload.brochure.hasCoverPageWithImage : "Y";
        return (
            <div>
                <div className="push"><h1>{brochure.payload.brochure.brochureId?"Edit":"Create"} Brochure</h1></div>
				<p className="red bold">{this.state.errorMessage}</p>
                <h2 className="pageTitle">Step 3 of 4: Brochure Information</h2>
                <hr className="clear" />
                <form className="brochureInformationForm" onSubmit={this.handleContinue.bind(this)} name="brochureInformationForm" id="brochureInformationForm">
                    <div className="push">
                        <h3>Header &amp; Footer</h3>
                        <table className="headerAndFooterTable formTableTypeA">
                            <tbody>
                                <tr>
                                    <td>
                                        Brochure Name
                                    </td>
                                    <td>
                                        <input size={40} defaultValue={brochure.payload.brochure.brochureName} className={this.state.error.brochureNameError} onBlur={this.handleBrochureParamsChange.bind(this, "brochureName")} name="brochureName" type="text" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Display my logo<br />
                                        <i className="unbold">(maximum 500 KB)</i>
                                    </td>
                                    <td>
                                        <input accept="image/jpeg,image/pjpeg,image/gif,image/png,image/bmp,image/x-windows-bmp" onChange={this.handleFileUpload.bind(this)} type="file" /> &nbsp; {this.state.fileUploadStatus === false && brochure.payload.brochure.customerLogo?<span className="bold">Selected Logo: <a href={s3BrochureUrl+brochure.payload.brochure.customerLogo} target="_blank">{brochure.payload.brochure.customerLogo}</a></span>:null}
										{this.state.fileUploadErrorMessage?<p className="red"><b>{this.state.fileUploadErrorMessage}</b></p>:null}
										{this.state.fileUploadStatusMessage?<p className="bold">{this.state.fileUploadStatusMessage}</p>:null}
                                    </td>
                                </tr>
                                {/*new brochure changes*/}
                                {/*<tr>
                                    <td>
                                        Footnote<br />
                                        <i className="unbold">(appears at the bottom of each page)</i>
                                    </td>
                                    <td className="containingTextArea">
                                        <textarea name="footnote" maxLength={100} defaultValue={brochure.payload.brochure.footNote?brochure.payload.brochure.footNote:""} rows={4} cols={40} onBlur={this.handleBrochureParamsChange.bind(this, "footNote")} />
                                    </td>
								</tr>*/}
                            </tbody>
						</table>
                    </div>
                    <div className="push">
                        <h3>Cover Page</h3>
                        <div className="indented">
						{coverPageTemplateOptions && coverPageTemplateOptions.length > 0 && <select value={brochure.payload.brochure.selectedCoverPageName} onChange={this.handleBrochureParamsChange.bind(this, "selectedCoverPageName")} name="selectedCoverPageName" className="selectedCoverPageName">
												{coverPageTemplateOptions.map((item, index) => {
													return <option value={item.coverPageTemplateName} key={(index + 1)}>{item.coverPageTemplateName}</option>
												})}
											</select>
										}
                            <div className="indented includeCoverPageContent">
                                <div className="coverPageColumns columns">
                                    <div className="column column1">
                                        <h4>
                                            Sales Contact Information
                                        </h4>
                                        <div className="shadedBox">
                                            <div className="push">
                                                <h5>For more information:</h5>
												{/*<p>
													<strong>User Name:</strong> {userDetails.firstName} {userDetails.lastName}<br />
													<strong>Email:</strong> {userDetails.email}
												</p>*/}
												<table className="formTableTypeA thisBrochurePreparedForTable">
	                                                <tbody>
														<tr>
															<td>Sales Contact Name</td>
															<td>
																<input className="fullWidth" value={brochure.payload.brochure.salesInfo.name?brochure.payload.brochure.salesInfo.name:""} onChange={this.handleForMoreInfoChange.bind(this, "name")} name="name" type="text" />
															</td>
														</tr>
														<tr>
															<td>Email</td>
															<td>
																<input className="fullWidth" value={brochure.payload.brochure.salesInfo.email?brochure.payload.brochure.salesInfo.email:""} onChange={this.handleForMoreInfoChange.bind(this, "email")} name="email" type="text" />
															</td>
														</tr>
	                                                    <tr>
	                                                        <td>Address 1</td>
	                                                        <td>
	                                                            <input className="fullWidth" value={brochure.payload.brochure.salesInfo.address1?brochure.payload.brochure.salesInfo.address1:""} onChange={this.handleForMoreInfoChange.bind(this, "address1")} name="address" type="text" />
	                                                        </td>
	                                                    </tr>
														<tr>
	                                                        <td>Address 2</td>
	                                                        <td>
	                                                            <input className="fullWidth" value={brochure.payload.brochure.salesInfo.address2?brochure.payload.brochure.salesInfo.address2:""} onChange={this.handleForMoreInfoChange.bind(this, "address2")} name="address" type="text" />
	                                                        </td>
	                                                    </tr>
	                                                    <tr>
	                                                        <td>City</td>
	                                                        <td>
	                                                            <input className="fullWidth" value={brochure.payload.brochure.salesInfo.city?brochure.payload.brochure.salesInfo.city:""} onChange={this.handleForMoreInfoChange.bind(this, "city")} id="cityField" name="city" type="text" />
	                                                        </td>
	                                                    </tr>
	                                                    <tr>
	                                                        <td>State</td>
	                                                        <td>
	                                                            <select id="stateField" value={brochure.payload.brochure.salesInfo.state?brochure.payload.brochure.salesInfo.state:""} onChange={this.handleForMoreInfoChange.bind(this, "state")} name="state">
	                                                                <option value>Select…</option>
																	<option value="AL">Alabama</option>
																	<option value="AK">Alaska</option>
																	<option value="AZ">Arizona</option>
																	<option value="AR">Arkansas</option>
																	<option value="CA">California</option>
																	<option value="CO">Colorado</option>
																	<option value="CT">Connecticut</option>
																	<option value="DE">Delaware</option>
																	<option value="FL">Florida</option>
																	<option value="GA">Georgia</option>
																	<option value="HI">Hawaii</option>
																	<option value="ID">Idaho</option>
																	<option value="IL">Illinois</option>
																	<option value="IN">Indiana</option>
																	<option value="IA">Iowa</option>
																	<option value="KS">Kansas</option>
																	<option value="KY">Kentucky</option>
																	<option value="LA">Louisiana</option>
																	<option value="ME">Maine</option>
																	<option value="MD">Maryland</option>
																	<option value="MA">Massachusetts</option>
																	<option value="MI">Michigan</option>
																	<option value="MN">Minnesota</option>
																	<option value="MS">Mississippi</option>
																	<option value="MO">Missouri</option>
																	<option value="MT">Montana</option>
																	<option value="NE">Nebraska</option>
																	<option value="NV">Nevada</option>
																	<option value="NH">New Hampshire</option>
																	<option value="NJ">New Jersey</option>
																	<option value="NM">New Mexico</option>
																	<option value="NY">New York</option>
																	<option value="NC">North Carolina</option>
																	<option value="ND">North Dakota</option>
																	<option value="OH">Ohio</option>
																	<option value="OK">Oklahoma</option>
																	<option value="OR">Oregon</option>
																	<option value="PA">Pennsylvania</option>
																	<option value="RI">Rhode Island</option>
																	<option value="SC">South Carolina</option>
																	<option value="SD">South Dakota</option>
																	<option value="TN">Tennessee</option>
																	<option value="TX">Texas</option>
																	<option value="UT">Utah</option>
																	<option value="VT">Vermont</option>
																	<option value="VA">Virginia</option>
																	<option value="WA">Washington</option>
																	<option value="WV">West Virginia</option>
																	<option value="WI">Wisconsin</option>
																	<option value="WY">Wyoming</option>
																	<option value="DC">District of Columbia</option>
	                                                            </select>
	                                                        </td>
	                                                    </tr>
														{this.state.error.zipCodeMoreInfoError === "error"
															?<tr><td></td><td><div className="red">Please enter a 5- or 9-digit ZIP code.</div></td></tr>
															:null
														}
	                                                    <tr>
	                                                        <td>ZIP Code</td>
	                                                        <td>
	                                                            <input id="zipCode" value={brochure.payload.brochure.salesInfo.zipCode?brochure.payload.brochure.salesInfo.zipCode:""} className={this.state.error.zipCodeMoreInfoError} onKeyPress={this.acceptsOnlyNumbers} onBlur={this.onBlurValidateZipCode.bind(this, 'zipCodeMoreInfoError')} onChange={this.handleForMoreInfoChange.bind(this, "zipCode")} name="zipCode" size={10} maxLength={10} type="text" />
	                                                        </td>
	                                                    </tr>
														{this.state.error.phoneNumberMoreInfoError === "error"
															?<tr><td></td><td><div className="red">Please enter a valid 10-digit phone number, starting with the area code.</div></td></tr>
															:null
														}
	                                                    <tr>
	                                                        <td>Phone Number</td>
	                                                        <td>
	                                                            <input onKeyPress={this.props.acceptNumbersOnly} className={"phoneNumberField " + this.state.error.phoneNumberMoreInfoError} value={brochure.payload.brochure.salesInfo.phone?brochure.payload.brochure.salesInfo.phone:""} onBlur={this.onBlurValidatePhoneNumber.bind(this, 'salesInfo', 'phoneNumberMoreInfoError')} onChange={this.handleForMoreInfoChange.bind(this, "phone")} id="phoneNumberField" name="phoneNumber" size={17} maxLength={17} type="text" />
	                                                        </td>
	                                                    </tr>
	                                                </tbody>
												</table>
                                            </div>
                                            <div>
                                                <h5>Additional Business Information</h5>
                                                <p>Examples: business hours, warranty info, price expiration dates. <i>(Maximum 400 character or 6 lines)</i></p>
                                                <textarea rows={8} onChange={this.handleForMoreInfoChange.bind(this, "additionalInfo")} maxLength="400" className="fullWidth" name="additionalBusinessInformation" value={brochure.payload.brochure.salesInfo && brochure.payload.brochure.salesInfo.additionalInfo?brochure.payload.brochure.salesInfo.additionalInfo:""} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="column column2">
                                        <h4 className="noMarginTop">Customer’s Information</h4>
                                        <div className="shadedBox">
                                            <h5>This brochure prepared for:</h5>
                                            <table className="formTableTypeA thisBrochurePreparedForTable">
                                                <tbody>
												{this.state.error.companyTitleError === "error"
														?<tr><td></td><td><div className="red">Error in Company's name. Please include a space before '&' character to proceed.</div></td></tr>
														:null
													}
													<tr>
	                                                    <td>Company Name</td>
	                                                    <td>
	                                                        <input className="fullWidth" defaultValue={brochure.payload.brochure.customerInfo.name?brochure.payload.brochure.customerInfo.name:""} onChange={this.handleCustomerInfoChange.bind(this, "name")} name="companyName" type="text" />
	                                                    </td>
	                                                </tr>
                                                    <tr>
                                                        <td>Address 1</td>
                                                        <td>
                                                            <input className="fullWidth" value={brochure.payload.brochure.customerInfo.address1?brochure.payload.brochure.customerInfo.address1:""} onChange={this.handleCustomerInfoChange.bind(this, "address1")} name="address" type="text" />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Address 2</td>
                                                        <td>
                                                            <input className="fullWidth" value={brochure.payload.brochure.customerInfo.address2?brochure.payload.brochure.customerInfo.address2:""} onChange={this.handleCustomerInfoChange.bind(this, "address2")} name="address2" type="text" />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>City</td>
                                                        <td>
                                                            <input className="fullWidth" value={brochure.payload.brochure.customerInfo.city?brochure.payload.brochure.customerInfo.city:""} onChange={this.handleCustomerInfoChange.bind(this, "city")} id="cityField" name="city" type="text" />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>State</td>
                                                        <td>
                                                            <select id="stateField" value={brochure.payload.brochure.customerInfo.state?brochure.payload.brochure.customerInfo.state:""} onChange={this.handleCustomerInfoChange.bind(this, "state")} name="state">
                                                                <option value>Select…</option>
																<option value="AL">Alabama</option>
																<option value="AK">Alaska</option>
																<option value="AZ">Arizona</option>
																<option value="AR">Arkansas</option>
																<option value="CA">California</option>
																<option value="CO">Colorado</option>
																<option value="CT">Connecticut</option>
																<option value="DE">Delaware</option>
																<option value="FL">Florida</option>
																<option value="GA">Georgia</option>
																<option value="HI">Hawaii</option>
																<option value="ID">Idaho</option>
																<option value="IL">Illinois</option>
																<option value="IN">Indiana</option>
																<option value="IA">Iowa</option>
																<option value="KS">Kansas</option>
																<option value="KY">Kentucky</option>
																<option value="LA">Louisiana</option>
																<option value="ME">Maine</option>
																<option value="MD">Maryland</option>
																<option value="MA">Massachusetts</option>
																<option value="MI">Michigan</option>
																<option value="MN">Minnesota</option>
																<option value="MS">Mississippi</option>
																<option value="MO">Missouri</option>
																<option value="MT">Montana</option>
																<option value="NE">Nebraska</option>
																<option value="NV">Nevada</option>
																<option value="NH">New Hampshire</option>
																<option value="NJ">New Jersey</option>
																<option value="NM">New Mexico</option>
																<option value="NY">New York</option>
																<option value="NC">North Carolina</option>
																<option value="ND">North Dakota</option>
																<option value="OH">Ohio</option>
																<option value="OK">Oklahoma</option>
																<option value="OR">Oregon</option>
																<option value="PA">Pennsylvania</option>
																<option value="RI">Rhode Island</option>
																<option value="SC">South Carolina</option>
																<option value="SD">South Dakota</option>
																<option value="TN">Tennessee</option>
																<option value="TX">Texas</option>
																<option value="UT">Utah</option>
																<option value="VT">Vermont</option>
																<option value="VA">Virginia</option>
																<option value="WA">Washington</option>
																<option value="WV">West Virginia</option>
																<option value="WI">Wisconsin</option>
																<option value="WY">Wyoming</option>
																<option value="DC">District of Columbia</option>
                                                            </select>
                                                        </td>
                                                    </tr>
													{this.state.error.zipCodeError === "error"
														?<tr><td></td><td><div className="red">Please enter a 5- or 9-digit ZIP code.</div></td></tr>
														:null
													}
                                                    <tr>
                                                        <td>ZIP Code</td>
                                                        <td>
                                                            <input id="zipCode" value={brochure.payload.brochure.customerInfo.zipCode?brochure.payload.brochure.customerInfo.zipCode:""} className={this.state.error.zipCodeError} onKeyPress={this.acceptsOnlyNumbers} onBlur={this.onBlurValidateZipCode.bind(this, "zipCodeError")} onChange={this.handleCustomerInfoChange.bind(this, "zipCode")} name="zipCode" size={10} maxLength={10} type="text" />
                                                        </td>
                                                    </tr>
													{this.state.error.phoneNumberError === "error"
														?<tr><td></td><td><div className="red">Please enter a valid 10-digit phone number, starting with the area code.</div></td></tr>
														:null
													}
                                                    <tr>
                                                        <td>Phone Number</td>
                                                        <td>
                                                            <input onKeyPress={this.props.acceptNumbersOnly} className={"phoneNumberField " + this.state.error.phoneNumberError} value={brochure.payload.brochure.customerInfo.phone?brochure.payload.brochure.customerInfo.phone:""} onBlur={this.onBlurValidatePhoneNumber.bind(this, "customerInfo", "phoneNumberError")} onChange={this.handleCustomerInfoChange.bind(this, "phone")} id="phoneNumberField" name="phoneNumber" size={17} maxLength={17} type="text" />
                                                        </td>
                                                    </tr>
                                                </tbody>
											</table>
                                        </div>
                                    </div>
                                </div> {/* / .coverPageColumns.columns */}
                            </div> {/* / .indented */}
                            
                        </div>
                    </div>
                    <div className="push">
                        <h3>Product Information</h3>
                        <div className="indented">
                            <p>
                                <label className="whichInformation">
                                    <input name="whichInformation" defaultChecked={brochure.payload.brochure.productInfo.hasProductNum==="Y"?true:false} defaultValue="productNumbers" type="checkbox" onClick={this.handleProductInfoChange.bind(this, "hasProductNum")} />
                                    <strong>Product Numbers</strong>
                                </label>
                            </p>
                            <p>
                                <label className="whichInformation">
                                    <input name="whichInformation" defaultChecked={brochure.payload.brochure.productInfo.hasProductSpec==="Y"?true:false} defaultValue="productSpecs" type="checkbox" onClick={this.handleProductInfoChange.bind(this, "hasProductSpec")} />
                                    <strong>Product Specs</strong>
                                </label>
                            </p>
							<p>
                                <label className="whichInformation">
                                    <input name="whichInformation" defaultChecked={brochure.payload.brochure.productInfo.hasSubmittalSheet==="Y"?true:false} defaultValue="submittalSheet" type="checkbox" onClick={this.handleProductInfoChange.bind(this, "hasSubmittalSheet")} />
                                    <strong>Submittal Sheet</strong>
                                </label>
                            </p>
                             {/* <p>
                                <label className="whichInformation">
                                    <input name="whichInformation" defaultChecked={brochure.payload.brochure.productInfo.hasWarrantyInfo==="Y"?true:false} defaultValue="warrantyInformation" type="checkbox" onClick={this.handleProductInfoChange.bind(this, "hasWarrantyInfo")} />
                                    <strong>Warranty Information</strong>
                                    <i>(included on separate pages)</i>
                                </label>
                            </p>
                            <p>
                                <label className="whichInformation">
                                    <input className="displayAlternateProductColorsCheckbox" defaultChecked={brochure.payload.brochure.productInfo.hasProductColor==="Y"?true:false} name="whichInformation" type="checkbox" onClick={this.handleProductInfoChange.bind(this, "hasProductColor")} />
                                    <strong>Display Alternate Product colors</strong>
                                </label>
                            </p>
                            <div className="indented displayAlternateProductColorsContent">
                                <p>
                                    <label className="whichAlternateColors">
                                        <input className="whichAlternateColorsRadioButton" name="whichAlternateColors" defaultValue="N" defaultChecked={brochure.payload.brochure.productInfo.hasColorChoice==="N"?true:false} type="radio" onClick={this.handleProductInfoChange.bind(this, "hasColorChoice")} />
                                        <strong>All alternate colors</strong>
                                    </label>
                                </p>
                                <p>
                                    <label className="whichAlternateColors">
                                        <input className="whichAlternateColorsRadioButton" name="whichAlternateColors" defaultValue="Y" defaultChecked={brochure.payload.brochure.productInfo.hasColorChoice==="Y"?true:false} type="radio" onClick={this.handleProductInfoChange.bind(this, "hasColorChoice")} />
                                        <strong>Only the ones selected</strong>
                                    </label>
                                </p>
                                <div className="indented selectAlternateColors">
                                    <p>
										<label className={"alternateColor " + (this.state.error.productColorError==="error"?"red":"")}>
											<input name="alternateColor" defaultChecked={brochure.payload.brochure.productInfo.productColors.indexOf("stainless")!==-1?true:false} defaultValue="stainless" type="checkbox" onClick={this.handleProductColorInfoChange.bind(this)} />
											Stainless
										</label>
										<label className={"alternateColor " + (this.state.error.productColorError==="error"?"red":"")}>
											<input name="alternateColor" defaultChecked={brochure.payload.brochure.productInfo.productColors.indexOf("slate")!==-1?true:false} defaultValue="slate" type="checkbox" onClick={this.handleProductColorInfoChange.bind(this)} />
											Slate
										</label>
										<label className={"alternateColor " + (this.state.error.productColorError==="error"?"red":"")}>
                                            <input name="alternateColor" defaultChecked={brochure.payload.brochure.productInfo.productColors.indexOf("blackStainless")!==-1?true:false} defaultValue="blackStainless" type="checkbox" onClick={this.handleProductColorInfoChange.bind(this)} />
                                            Black Stainless
                                        </label>
										<label className={"alternateColor " + (this.state.error.productColorError==="error"?"red":"")}>
                                            <input name="alternateColor" defaultChecked={brochure.payload.brochure.productInfo.productColors.indexOf("blackSlate")!==-1?true:false} defaultValue="blackSlate" type="checkbox" onClick={this.handleProductColorInfoChange.bind(this)} />
                                            Black Slate
                                        </label>
										<label className={"alternateColor " + (this.state.error.productColorError==="error"?"red":"")}>
                                            <input name="alternateColor" defaultChecked={brochure.payload.brochure.productInfo.productColors.indexOf("matteWhite")!==-1?true:false} defaultValue="matteWhite" type="checkbox" onClick={this.handleProductColorInfoChange.bind(this)} />
                                            Matte White
                                        </label>
                                        <label className={"alternateColor " + (this.state.error.productColorError==="error"?"red":"")}>
                                            <input name="alternateColor" defaultChecked={brochure.payload.brochure.productInfo.productColors.indexOf("matteBlack")!==-1?true:false} defaultValue="matteBlack" type="checkbox" onClick={this.handleProductColorInfoChange.bind(this)} />
                                            Matte Black
                                        </label>
										<label className={"alternateColor " + (this.state.error.productColorError==="error"?"red":"")}>
                                            <input name="alternateColor" defaultChecked={brochure.payload.brochure.productInfo.productColors.indexOf("platinumGlass")!==-1?true:false} defaultValue="platinumGlass" type="checkbox" onClick={this.handleProductColorInfoChange.bind(this)} />
                                            Platinum Glass
                                        </label>
                                        <label className={"alternateColor " + (this.state.error.productColorError==="error"?"red":"")}>
                                            <input name="alternateColor" defaultChecked={brochure.payload.brochure.productInfo.productColors.indexOf("customPanels")!==-1?true:false} defaultValue="customPanels" type="checkbox" onClick={this.handleProductColorInfoChange.bind(this)} />
                                            Custom Panels
                                        </label>
                                        <label className={"alternateColor " + (this.state.error.productColorError==="error"?"red":"")}>
                                            <input name="alternateColor" defaultChecked={brochure.payload.brochure.productInfo.productColors.indexOf("white")!==-1?true:false} defaultValue="white" type="checkbox" onClick={this.handleProductColorInfoChange.bind(this)} />
                                            White
                                        </label>
                                        <label className={"alternateColor " + (this.state.error.productColorError==="error"?"red":"")}>
                                            <input name="alternateColor" defaultChecked={brochure.payload.brochure.productInfo.productColors.indexOf("black")!==-1?true:false} defaultValue="black" type="checkbox" onClick={this.handleProductColorInfoChange.bind(this)} />
                                            Black
                                        </label>
                                        <label className={"alternateColor " + (this.state.error.productColorError==="error"?"red":"")}>
                                            <input name="alternateColor" defaultChecked={brochure.payload.brochure.productInfo.productColors.indexOf("bisque")!==-1?true:false} defaultValue="bisque" type="checkbox" onClick={this.handleProductColorInfoChange.bind(this)} />
                                            Bisque
                                        </label>

                                    </p>
                                </div>
                            </div> */}
                        </div>
                    </div>
                    <p className="textRight">
                        <input value="Continue" type="submit" />
                    </p>
                </form>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return { state };
};
const mapDispatchToProps = (dispatch) => ({
	updateBrochureProductInfo: (payload) => dispatch(updateBrochureProductInfo(payload)),
	updateBrochureParameter: (payload) => dispatch(updateBrochureParameter(payload)),
	updateBrochureCustomerInfo: (payload) => dispatch(updateBrochureCustomerInfo(payload)),
	updateBrochureForMoreInfo: (payload) => dispatch(updateBrochureForMoreInfo(payload)),
	updateBrochureCoverPageInfo: (payload) => dispatch(updateBrochureCoverPageInfo(payload)),
	updateBrochureProductColorInfo: (payload) => dispatch(updateBrochureProductColorInfo(payload))
});

BrochureStep3 = connect(mapStateToProps, mapDispatchToProps)(BrochureStep3);
export default BrochureStep3;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Brochure/step3.js